// extracted by mini-css-extract-plugin
module.exports = {"tabs":"formLine_tabs__1LhxB","eliminar":"formLine_eliminar__1NWXG","config-list":"formLine_config-list__TqAb3","delete-config":"formLine_delete-config__3u8pN"};